/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnitAllOfReservation } from './UnitAllOfReservation';
import {
    UnitAllOfReservationFromJSON,
    UnitAllOfReservationFromJSONTyped,
    UnitAllOfReservationToJSON,
    UnitAllOfReservationToJSONTyped,
} from './UnitAllOfReservation';

/**
 * 
 * @export
 * @interface CreateUnitRequest
 */
export interface CreateUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUnitRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    floor: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUnitRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    livingArea: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    totalArea: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    numberOfBalconies: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    numberOfRooms: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    numberOfBathrooms: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUnitRequest
     */
    price: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUnitRequest
     */
    photoURLs?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUnitRequest
     */
    status: CreateUnitRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUnitRequest
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnitRequest
     */
    typeId?: string;
    /**
     * 
     * @type {UnitAllOfReservation}
     * @memberof CreateUnitRequest
     */
    reservation?: UnitAllOfReservation;
}


/**
 * @export
 */
export const CreateUnitRequestStatusEnum = {
    Available: 'available',
    Reserved: 'reserved',
    Sold: 'sold'
} as const;
export type CreateUnitRequestStatusEnum = typeof CreateUnitRequestStatusEnum[keyof typeof CreateUnitRequestStatusEnum];


/**
 * Check if a given object implements the CreateUnitRequest interface.
 */
export function instanceOfCreateUnitRequest(value: object): value is CreateUnitRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('floor' in value) || value['floor'] === undefined) return false;
    if (!('livingArea' in value) || value['livingArea'] === undefined) return false;
    if (!('totalArea' in value) || value['totalArea'] === undefined) return false;
    if (!('numberOfBalconies' in value) || value['numberOfBalconies'] === undefined) return false;
    if (!('numberOfRooms' in value) || value['numberOfRooms'] === undefined) return false;
    if (!('numberOfBathrooms' in value) || value['numberOfBathrooms'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    return true;
}

export function CreateUnitRequestFromJSON(json: any): CreateUnitRequest {
    return CreateUnitRequestFromJSONTyped(json, false);
}

export function CreateUnitRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUnitRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'floor': json['floor'],
        'description': json['description'] == null ? undefined : json['description'],
        'livingArea': json['livingArea'],
        'totalArea': json['totalArea'],
        'numberOfBalconies': json['numberOfBalconies'],
        'numberOfRooms': json['numberOfRooms'],
        'numberOfBathrooms': json['numberOfBathrooms'],
        'price': json['price'],
        'photoURLs': json['photoURLs'] == null ? undefined : json['photoURLs'],
        'status': json['status'],
        'projectId': json['projectId'],
        'typeId': json['typeId'] == null ? undefined : json['typeId'],
        'reservation': json['reservation'] == null ? undefined : UnitAllOfReservationFromJSON(json['reservation']),
    };
}

export function CreateUnitRequestToJSON(json: any): CreateUnitRequest {
    return CreateUnitRequestToJSONTyped(json, false);
}

export function CreateUnitRequestToJSONTyped(value?: CreateUnitRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'floor': value['floor'],
        'description': value['description'],
        'livingArea': value['livingArea'],
        'totalArea': value['totalArea'],
        'numberOfBalconies': value['numberOfBalconies'],
        'numberOfRooms': value['numberOfRooms'],
        'numberOfBathrooms': value['numberOfBathrooms'],
        'price': value['price'],
        'photoURLs': value['photoURLs'],
        'status': value['status'],
        'projectId': value['projectId'],
        'typeId': value['typeId'],
        'reservation': UnitAllOfReservationToJSON(value['reservation']),
    };
}

